import { render, staticRenderFns } from "./CustomerSupportTicketStatusesComponent.vue?vue&type=template&id=26f1e4fd"
import script from "./CustomerSupportTicketStatusesComponent.vue?vue&type=script&lang=js"
export * from "./CustomerSupportTicketStatusesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports